import { useEffect } from 'react';
import { useClientPreferences } from './useClientPreferences';

/**
 * Applies the user's theme preference to the document root element.
 * Call this once in CustomerLayout.
 */
export function useApplyTheme() {
  const { preferences } = useClientPreferences();

  useEffect(() => {
    const root = document.documentElement;
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');

    function apply(theme: string) {
      if (theme === 'light') {
        root.classList.remove('dark');
        root.classList.add('light');
      } else if (theme === 'dark') {
        root.classList.remove('light');
        root.classList.add('dark');
      } else {
        // system
        if (prefersDark.matches) {
          root.classList.remove('light');
          root.classList.add('dark');
        } else {
          root.classList.remove('dark');
          root.classList.add('light');
        }
      }
    }

    apply(preferences.theme);

    // Listen for system changes when theme is 'system'
    const handler = () => {
      if (preferences.theme === 'system') apply('system');
    };
    prefersDark.addEventListener('change', handler);
    return () => {
      prefersDark.removeEventListener('change', handler);
      // Reset to dark (app default) when leaving customer area
      root.classList.remove('light');
      root.classList.add('dark');
    };
  }, [preferences.theme]);
}
